import DischargeForm from './DischargeForm';

export default DischargeForm;
